import React from 'react'
// components
import { ReduxEntitySelect } from 'components/FormElements'
// graphql
import { RISK_TEMPLATE_SELECT_QUERY } from 'graphql/risk/queries'
// views
import { TemplateSelectWrapper } from './views'
// utils
import { required } from 'utils/validators'
import { riskTemplatesProps } from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'

interface Props {
  field: string
}

const ScheduleTemplateSelect: React.FC<Props> = ({ field }) => (
  <TemplateSelectWrapper>
    <ReduxEntitySelect
      label='Form'
      validate={required}
      menuPortalTarget={null}
      name={`${field}.riskTemplate`}
      query={RISK_TEMPLATE_SELECT_QUERY}
      {...riskTemplatesProps}
    />
  </TemplateSelectWrapper>
)

export default ScheduleTemplateSelect
